// extracted by mini-css-extract-plugin
export var icon = "_an-3";
export var subtitle = "_an-2";
export var title = "_an-1";
export var value = "_an-0";